import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AboutusComponent } from './aboutus.component';

@NgModule({
  declarations: [
    AboutusComponent
  ],
  exports:[AboutusComponent],
  providers: [],
})
export class AboutusModule { }



// WEBPACK FOOTER //
// ./src/app/about_us/aboutus.module.ts